import { faBars, faSearch } from '@fortawesome/pro-solid-svg-icons'
import { Fragment, useCallback, useRef, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import useOnClickOutside from '../../../../utils/hooks/useOnClickOut'
import { AllReduxAppPayloads, GlobalContext } from '../../../../utils/reducers'
import { CurrentPagePayload } from '../../../../utils/reducers/globals/currentPage'
import { joinAndRemoveDuplicatedBars } from '../../../CreateRoutering/functions'
import { Routes } from '../../../CreateRoutering/types'
import { ModalOpenedSetTy, ModalOpenedTy } from '../../../Modal/types'
import TwinIcon, { TwinIconProp } from '../../../TwinIcon'
import '../left_menu.sass'
import { getChildrenMenuItems } from './functions'
import OpenedMenuDropDown from './OpenedMenuDropDown'
import { SearchMenuWithSearchBar } from './SearchMenu'

type OpenedMenuProps = HeaderOpenedMenuProps & ReduxOpenedMenuConnector & {
    routes: Routes
    opened: ModalOpenedTy
    onClick: () => void
}

const OpenedMenu: React.FC<OpenedMenuProps> = ({ currentPage, opened, routes, setOpened, onClick }) => {
    const position = getChildrenMenuItems(routes, currentPage)
    if (!opened) {
        return null
    }
    return (
        <div className='flex flex-col bg-gray-3E text-white second_left_menu'>
            {routes[position] ?
                <Fragment>
                    <HeaderOpenedMenu text={routes[position].text} setOpened={setOpened} routes={routes} />
                    <OpenedMenuItems onClick={onClick} routes={routes[position].childs} currentPage={currentPage} parentLink={routes[position].link} />
                </Fragment>
                : null
            }
        </div>
    )
}

interface HeaderOpenedMenuProps {
    text?: string
    setOpened: ModalOpenedSetTy
    routes: Routes
}

const HeaderOpenedMenu: React.FC<HeaderOpenedMenuProps> = ({ text, setOpened, routes }) => {
    return (
        <div className='flex justify-between items-center pr-12'>
            <h3>{text}</h3>
            <div className='flex'>
                <MainSearch routes={routes} />
                <TwinIcon icon={faBars} size='lg' className='cursor-pointer text-white opacity-50' onClick={() => setOpened(null)}/>
            </div>
        </div>
    )
}

interface MainSearchProps {
    routes: Routes
    icon?: TwinIconProp
}

export const MainSearch: React.FC<MainSearchProps> = ({ routes, icon }) => {
    const { searchOpen, setSearchOpen, toggleSearch, ref } = useMainSearchLogic()
    return (
        <div ref={ref} className='flex justify-center relative main_app_search_icon'>
            <TwinIcon icon={icon || faSearch} fontSize={16} onClick={toggleSearch} className='mr-15 mt-1 text-white cursor-pointer opacity-50' />
            {searchOpen ?
                <SearchMenuWithSearchBar routes={routes} onClose={() => setSearchOpen(false)} />
                : null
            }
        </div>
    )
}

const useMainSearchLogic = () => {
    const [searchOpen, setSearchOpen] = useState(false)
    const ref = useRef<any>(null)

    const toggleSearch = useCallback(() => {
        setSearchOpen((old) => !old)
    }, [])

    useOnClickOutside(ref, () => setSearchOpen(false))

    return { searchOpen, setSearchOpen, toggleSearch, ref }
}

interface OpenedMenuItemsProps {
    routes?: Routes
    currentPage: CurrentPagePayload
    parentLink: string
    onClick: () => void
}

const OpenedMenuItems: React.FC<OpenedMenuItemsProps> = ({ routes, currentPage, parentLink, onClick }) => {
    const renderOpenedMenuItems: JSX.Element[] = []
    if (!currentPage) {
        return null
    }
    for (const key in routes) {
        const item = routes[parseInt(key)]
        renderOpenedMenuItems.push(<OpenedMenuDropDown onClick={onClick} key={parentLink + item.link} route={item} currentPage={currentPage} parentLink={joinAndRemoveDuplicatedBars(parentLink, item.link)}/>)
    }
    return (
        <div className='mt-48 pr-12 left_menu_parent overflow-auto'>
            {renderOpenedMenuItems}
        </div>
    )
}

const openedMenuDispatch = {
    setChangePage: (payload: CurrentPagePayload) => ({ type: 'CHANGE_CURRENTPAGE', payload }),
}
const mapOpenedMenuConnector = (state: AllReduxAppPayloads) => ({ currentPage: state.currentPage })
export const openedMenuConnector = connect(mapOpenedMenuConnector, openedMenuDispatch, null, { context: GlobalContext })
export type ReduxOpenedMenuConnector = ConnectedProps<typeof openedMenuConnector>

export default openedMenuConnector(OpenedMenu)